/* eslint-disable import/prefer-default-export */

import { getValueAfterCheckEmpty } from '@/utils/string';

const defaultFormatter = (row, column, value) => getValueAfterCheckEmpty(value);

export const columnDefault = {
  headerAlign: 'left',
  align: 'left',
};

export const defaultDetailHeaderText = '더보기';

export const defaultDetailHeaderColumn = {
  label: defaultDetailHeaderText,
  width: 60,
  align: 'center',
};

export const defaultPagination = {
  currentPage: 1,
  pageSize: 25,
  pageSizes: [25, 50, 100, 300, 500],
  layout: 'total, sizes, prev, pager, next',
};

const selectionColumn = {
  type: 'selection',
  width: 55,
};

const objNameColumn = {
  prop: 'objName',
  remoteProp: 'o.obj_name',
  sortProp: 'objName',
  label: '장비명',
  searchable: true,
  sortable: true,
  formatter: defaultFormatter,
};
const ipColumn = {
  prop: 'ipaddress',
  remoteProp: 'o.ipaddress',
  sortProp: 'ipaddress',
  label: 'IP 주소',
  width: 120,
  searchable: true,
  sortable: true,
  formatter: defaultFormatter,
};

const netdeviceColumns = [
  selectionColumn,
  objNameColumn,
  ipColumn,
  {
    prop: 'objtypeName',
    remoteProp: 'ot.objtype_name',
    sortProp: 'objtypeName',
    label: '장비 종류',
    searchable: true,
    sortable: true,
    formatter: defaultFormatter,
  },
  {
    prop: 'objCompanyName',
    remoteProp: 'oc.obj_company_name',
    sortProp: 'objCompanyName',
    label: '제조사',
    searchable: true,
    sortable: true,
    formatter: defaultFormatter,
  },
];

const netinterfaceColumns = [
  selectionColumn,
  {
    prop: 'objName',
    remoteProp: 'o.obj_name',
    sortProp: 'objName',
    label: '인터페이스명',
    searchable: true,
    sortable: true,
    formatter: defaultFormatter,
  },
  {
    prop: 'deviceName',
    remoteProp: 'device_name',
    sortProp: 'deviceName',
    label: '장비명',
    searchable: true,
    sortable: true,
    formatter: defaultFormatter,
  },
  {
    prop: 'ipaddress',
    remoteProp: 'o.ipaddress',
    sortProp: 'ipaddress',
    label: 'IP 주소',
    searchable: true,
    sortable: true,
    formatter: defaultFormatter,
  },
  {
    prop: 'objCompanyName',
    remoteProp: 'oc.obj_company_name',
    sortProp: 'objCompanyName',
    label: '제조사',
    searchable: true,
    sortable: true,
    formatter: defaultFormatter,
  },
];

const e2eColumns = [
  selectionColumn,
  {
    prop: 'objName',
    remoteProp: 'o.obj_name',
    sortProp: 'objName',
    label: 'E2E 서비스명',
    searchable: true,
    sortable: true,
    formatter: defaultFormatter,
  },
  {
    prop: 'httpUrl',
    remoteProp: 'svc.http_url',
    sortProp: 'httpUrl',
    label: 'URL',
    searchable: true,
    formatter: defaultFormatter,
  },
  {
    prop: 'protocol',
    remoteProp: 'svc.protocol',
    sortProp: 'protocol',
    label: '프로토콜',
    searchable: true,
    sortable: true,
    formatter: defaultFormatter,
  },
];

const serverColumns = [
  selectionColumn,
  objNameColumn,
  ipColumn,
  {
    prop: 'objtypeName',
    remoteProp: 'ot.objtype_name',
    sortProp: 'objtypeName',
    label: 'OS 종류',
    searchable: true,
    sortable: true,
    formatter: defaultFormatter,
  },
];

const dbColumns = [
  selectionColumn,
  objNameColumn,
  ipColumn,
  {
    prop: 'objtypeName',
    remoteProp: 'ot.objtype_name',
    sortProp: 'objtypeName',
    label: 'DB 종류',
    searchable: true,
    sortable: true,
    formatter: defaultFormatter,
  },
];

const sensorColumns = [
  selectionColumn,
  objNameColumn,
  ipColumn,
  {
    prop: 'objtypeName',
    remoteProp: 'ot.objtype_name',
    sortProp: 'objtypeName',
    label: '센서 종류',
    searchable: true,
    sortable: true,
    formatter: defaultFormatter,
  },
];

const serviceColumns = [
  selectionColumn,
  {
    prop: 'objName',
    remoteProp: 'o.obj_name',
    sortProp: 'objName',
    label: '서비스명',
    searchable: true,
    sortable: true,
    formatter: defaultFormatter,
  },
];

const hypervisorTypeColumn = {
  prop: 'hypervisorType',
  remoteProp: 'vv.hypervisor_type',
  sortProp: 'hypervisorType',
  label: '하이퍼바이저 종류',
  width: 120,
  searchable: true,
  sortable: true,
  formatter: defaultFormatter,
};

const virtualcenterColumn = {
  prop: 'virtualcenterName',
  remoteProp: 'vv.virtualcenter_name',
  sortProp: 'virtualcenterName',
  label: '가상화센터명',
  searchable: true,
  sortable: true,
  formatter: defaultFormatter,
};

const virtualcenterColumns = [
  selectionColumn,
  hypervisorTypeColumn,
  virtualcenterColumn,
  {
    prop: 'objName',
    remoteProp: 'o.obj_name',
    sortProp: 'objName',
    label: '가상화센터명',
    searchable: true,
    sortable: true,
    formatter: defaultFormatter,
  },
];

const hostClusterColumns = [
  selectionColumn,
  hypervisorTypeColumn,
  virtualcenterColumn,
  {
    prop: 'objName',
    remoteProp: 'o.obj_name',
    sortProp: 'objName',
    label: '호스트 클러스터명',
    searchable: true,
    sortable: true,
    formatter: defaultFormatter,
  },
];

const hostColumns = [
  selectionColumn,
  hypervisorTypeColumn,
  virtualcenterColumn,
  {
    prop: 'objName',
    remoteProp: 'o.obj_name',
    sortProp: 'objName',
    label: '호스트명',
    searchable: true,
    sortable: true,
    formatter: defaultFormatter,
  },
  ipColumn,
];

const vmColumns = [
  selectionColumn,
  hypervisorTypeColumn,
  virtualcenterColumn,
  {
    prop: 'objName',
    remoteProp: 'o.obj_name',
    sortProp: 'objName',
    label: 'VM명',
    searchable: true,
    sortable: true,
    formatter: defaultFormatter,
  },
  ipColumn,
  {
    prop: 'hostName',
    remoteProp: 'vh.host_name',
    sortProp: 'hostName',
    label: '호스트명',
    searchable: true,
    sortable: true,
    formatter: defaultFormatter,
  },
];

const storageClusterColumns = [
  selectionColumn,
  hypervisorTypeColumn,
  virtualcenterColumn,
  {
    prop: 'objName',
    remoteProp: 'o.obj_name',
    sortProp: 'objName',
    label: '스토리지클러스터명',
    searchable: true,
    sortable: true,
    formatter: defaultFormatter,
  },
];

const storageColumns = [
  selectionColumn,
  hypervisorTypeColumn,
  virtualcenterColumn,
  {
    prop: 'objName',
    remoteProp: 'o.obj_name',
    sortProp: 'objName',
    label: '스토리지명',
    searchable: true,
    sortable: true,
    formatter: defaultFormatter,
  },
];

const emsColumns = [
  selectionColumn,
  objNameColumn,
  ipColumn,
  {
    prop: 'objtypeName',
    remoteProp: 'ot.objtype_name',
    sortProp: 'objtypeName',
    label: '장비 종류',
    searchable: true,
    sortable: true,
    formatter: defaultFormatter,
  },
];

const wasColumns = [
  selectionColumn,
  {
    prop: 'objName',
    remoteProp: 'o.obj_name',
    sortProp: 'objName',
    label: '인스턴스명',
    searchable: true,
    sortable: true,
    formatter: defaultFormatter,
  },
  ipColumn,
  {
    prop: 'objtypeName',
    remoteProp: 'ot.objtype_name',
    sortProp: 'objtypeName',
    label: 'WAS 종류',
    searchable: true,
    sortable: true,
    formatter: defaultFormatter,
  },
];

export const physicalObjTableColumns = {
  netdeviceColumns,
  netinterfaceColumns,
  e2eColumns,
  serverColumns,
  dbColumns,
  sensorColumns,
  serviceColumns,
  hostClusterColumns,
  hostColumns,
  vmColumns,
  storageClusterColumns,
  storageColumns,
  emsColumns,
  wasColumns,
};

export const agentPhysicalObjTableColumns = {
  netdeviceColumns,
  netinterfaceColumns,
  e2eColumns,
  serverColumns,
  dbColumns,
  sensorColumns,
  serviceColumns,
  virtualcenterColumns,
  emsColumns,
  wasColumns,
};



// WEBPACK FOOTER //
// ./src/constants/table.js